/* eslint-disable-next-line */
(function ($, ajax_localize) {
	jQuery(document).ready(function(){

		$(".btn-load-more").each(function () {

			let listItemHolder = $("#post-archive-list-holder");

			let listItemsLoader = $(".list-items-loader", listItemHolder);

			// Hide the button if there aren't any more posts to load
			if((listItemsLoader.length === 0) || (parseInt(listItemsLoader.data("page")) > parseInt(listItemsLoader.data("max-pages")))){
				$(this).hide();
			}

			$(this).on("click", function (evt) {

				evt.preventDefault();

				loadMorePosts();

			});

		});

		// $("#post-archive-filter-form")
		// 	.on("change", "select.form-control", function(){
		//
		// 		checkClearFilterBtnVisibility();
		//
		// 		loadMorePosts(true);
		//
		// 		updateWindowHref();
		//
		// 	})
		// 	.on("input", 'input[type="search"]', function(){
		//
		// 		if(($(this).val() === "") || ($(this).val().length > 2)){
		// 			delayPostArchiveSearch();
		// 		}
		//
		// 	});
		//
		// if($(".btn-clear-filter", "#post-archive-filter-form").length > 0){
		//
		// 	checkClearFilterBtnVisibility();
		//
		// 	$(".btn-clear-filter", "#post-archive-filter-form").on("click", function(evt){
		//
		// 		evt.preventDefault();
		//
		// 		$("#post-archive-filter-form").find("input[type='search'], .form-control").each(function(){
		// 			$(this).val("");
		// 		});
		//
		// 		// Clear query string
		// 		let clearedUrl = window.location.href.replace(window.location.search, "");
		//
		// 		window.history.replaceState({path: clearedUrl}, "", clearedUrl);
		//
		// 		$(this).hide();
		//
		// 		loadMorePosts(true);
		//
		// 	});
		//
		// }

	});

	let delayTimer;

	function delayPostArchiveSearch(){

		clearTimeout(delayTimer);

		delayTimer = setTimeout(function() {
			checkClearFilterBtnVisibility();
			loadMorePosts(true);
			updateWindowHref();
		}, 400);

	}

	function loadMorePosts(isFilterRequest = false){

		var listItemHolder = $("#post-archive-list-holder");

		var loadMoreBtn = listItemHolder.closest(".archive-listing-section").find(".btn-load-more");
		var listItemLoader = $(".list-items-loader", listItemHolder);

		if (loadMoreBtn.is(".loading")) {
			return false;
		}

		// Save the button's text so we can restore it when removing the loading state
		var origButtonText = loadMoreBtn.html();

		loadMoreBtn
			.attr("disabled", true)
			.addClass("loading")
			.text("Loading...");

		var action = "get_posts";

		// Check if the list item loader has a custom action set
		if ((listItemLoader.data("action") !== undefined) && (listItemLoader.data("action") !== "")) {
			action = listItemLoader.data("action");
		}

		let requestData = listItemLoader.data();

		requestData['filterArgs'] = $("#post-archive-filter-form").serialize();

		if(isFilterRequest){

			requestData['page'] = 1;

		}

		$.post(
			ajax_localize.ajax_url,
			{
				"action": action,
				"data": $.param(requestData),
			},
			function (data) {

				// Remove the existing list item loader since a new one will be included in the response
				listItemLoader.remove();

				// If new faq items were returned
				if (data) {

					loadMoreBtn
						.attr("disabled", false)
						.removeClass("loading")
						.html(origButtonText);

					var newListItems = $($.parseHTML(data));

					if(isFilterRequest){

						listItemHolder.fadeOut(400, function(){

							$(this).empty().append(newListItems);

							$(this).fadeIn(400);

							checkLoadMoreBtnVisibility($(this));

						});

					}else{

						newListItems.filter(":not(.list-items-loader)").addClass("fade");

						listItemHolder.append(newListItems);

						// Wait a split second before adding class to fade in new faqs
						setTimeout(function () {
							newListItems.filter(".fade").addClass("show");
						}, 100);

						checkLoadMoreBtnVisibility(listItemHolder);

					}

				} else {

					loadMoreBtn.fadeOut(400);

				}

			}
		);

	}

	function updateWindowHref(){

		let newFilterUrl = "?" + $("#post-archive-filter-form").serialize();

		window.history.replaceState({path: newFilterUrl}, "", newFilterUrl);

	}

	function checkLoadMoreBtnVisibility(listItemHolder){

		let newListItemLoader = $(".list-items-loader", listItemHolder);

		let loadMoreBtn = listItemHolder.closest(".archive-listing-section").find(".btn-load-more");

		// If the next page number is higher than the maximum number of pages, hide the load more button
		if(parseInt(newListItemLoader.data("page")) > parseInt(newListItemLoader.data("max-pages"))){

			loadMoreBtn.hide();

		}else if(loadMoreBtn.is(":hidden")){

			loadMoreBtn.show();

		}

	}

	function checkClearFilterBtnVisibility(){

		let filterFormEmpty = true;

		$("#post-archive-filter-form").find("input[type='search'], .form-control").each(function(){

			// If any filter fields have a value, show the clear button
			if($(this).val() !== ""){
				filterFormEmpty = false;
			}

		});

		// If the filter form doesn't have any values set, hide the clear filter button
		if(filterFormEmpty){

			$(".btn-clear-filter", "#post-archive-filter-form").hide();

		// Otherwise, show it
		}else{

			$(".btn-clear-filter", "#post-archive-filter-form").show();

		}

	}

/* eslint-disable-next-line */
})(jQuery, ajax_localize);